import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { termList } from 'app/core/models/api/com/com0102'
import { selectTermCom0102 } from 'app/core/services/com/com.service'
import { RootState } from 'app/core/store'
/**
 * 약관에 링크 정보를 보관한다.
 * /prd/com/com01/com0102호출 결과물
 */
type TermDict = {
    [key: string]: termList
}
type TermData = {
    dic: TermDict
    items: termList[]
}

const slice = createSlice({
    name: 'terms',
    initialState: { dic: null, items: null } as TermData,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            selectTermCom0102.matchFulfilled,
            (state, action) => {
                //raw data를 선 가공해서 적재시킨다.
                const rawTerms = [...action.payload.data]
                const dic: TermDict = {}
                rawTerms.forEach((rawTerm, index) => {
                    dic[rawTerm.ccddId] = rawTerm
                })
                state.dic = dic
                state.items = rawTerms
            }
        )
    },
})
export const selectorTermData = (state: RootState) => {
    return state.terms
}

export const selectorTerm = (termId: string) => (state: RootState) => {
    return state.terms.dic[termId]
}
export const selectorTermDic = (state: RootState) => {
    return state.terms.dic
}
export const selectorTermItems = (state: RootState) => {
    return state.terms.items
}

export default slice.reducer
